import { useMemo } from 'react'
import { AddressZero } from '@ethersproject/constants'
import { useUpdaterChainId } from '~/hooks'
import { useSpotSwapPair, useSpotSwapUserConfig } from '~/state/dex/hooks'
import { isMainnetOrSepolia } from '~/utils/chain'

export function useIsSendByRelayer() {
  const [inputToken] = useSpotSwapPair()
  const { sendByRelayer, isCrossSwap } = useSpotSwapUserConfig()
  const chainId = useUpdaterChainId()

  const isSendByRelayer = useMemo(() => {
    const isTakerETH = inputToken?.address === AddressZero
    const isMainnetOrSepoliaFlag = isMainnetOrSepolia(chainId)
    return (
      isMainnetOrSepoliaFlag && !isTakerETH && !isCrossSwap && sendByRelayer
    )
  }, [inputToken?.address, sendByRelayer, chainId])

  return isSendByRelayer
}
